import classNames from 'clsx';
import * as React from 'react';

import { NewbuildingImage } from './NewbuildingImage';
import { NewbuildingLocation } from './NewbuildingLocation';
import { NewbuildingRating } from './NewbuildingRatingV2';
import { NewbuildingTag } from './NewbuildingTag';
import * as styles from './NewbuildingPromoPopup.css';
import { IUndergroundInfo } from '../../types/newbuilding';
import { UIHeading4 } from '@cian/ui-kit';

interface INewbuildingPromoPopupProps {
  newbuildingName: string;
  newbuildingUrl: string;
  address: string;
  houseName: string | null;
  imageUrl: string;
  reviewsRate: string;
  reviewsRateUrl: string;
  priceFrom: string;
  promoName: string | null;
  promoUrl: string | null;
  undergrounds: IUndergroundInfo[];
  contactsBlock: React.ReactNode;
  isVisibleContacts: boolean;
  onNewbuildingClick(): void;
}

export function NewbuildingPromoPopup({
  newbuildingName,
  newbuildingUrl,
  imageUrl,
  reviewsRate,
  reviewsRateUrl,
  promoName,
  promoUrl,
  priceFrom,
  undergrounds,
  contactsBlock,
  isVisibleContacts,
  address,
  onNewbuildingClick,
}: INewbuildingPromoPopupProps) {
  return (
    <div
      className={classNames(styles['container'], isVisibleContacts && styles['is-visible-contacts'])}
      data-name="NewbuildingPromoPopup"
    >
      <div className={styles['image']}>
        <NewbuildingImage name={newbuildingName} imageUrl={imageUrl} isRedesign />
      </div>
      <div className={styles['content']}>
        {promoName && promoUrl && <NewbuildingTag promoName={promoName} promoUrl={promoUrl} />}
        <div className={styles['inner-content']}>
          <a
            data-testid="newbuilding-name"
            data-name="NewbuildingDescription"
            className={styles['title']}
            href={newbuildingUrl}
            target="_blank"
            rel="noreferrer"
            onClick={onNewbuildingClick}
          >
            <UIHeading4>ЖК «{newbuildingName}»</UIHeading4>
          </a>
          {priceFrom && <UIHeading4 data-testid="newbuilding-price">От {priceFrom}</UIHeading4>}
          <NewbuildingRating reviewsRate={reviewsRate} reviewsRateUrl={reviewsRateUrl} />
          <NewbuildingLocation address={address} undergrounds={undergrounds} isRedesign />
        </div>
      </div>
      <div className={styles['footer']}>{contactsBlock}</div>
    </div>
  );
}
